// src/core/tables/helpers/DiscontinuedToggleButton.tsx
import { useMemo } from 'react';
import type { ReactElement } from 'react';
import { Box } from '@mui/material';
import CustomButton from 'src/core/ui/CustomButton';
import { getNestedValue } from 'src/core/settings/settings';

const DiscontinuedToggleButton = ({ settings, setSetting, tableName, icon, tooltipOn = "Hide discontinued", tooltipOff = "Show discontinued", onColor = 'error.main', offColor = 'text.disabled', }: DiscontinuedToggleButtonProps) => {
  const keyPath = useMemo(() => [SETTING_KEY, tableName], [tableName]);
  const isOn = useMemo(() => { return getNestedValue(settings, keyPath, false); }, [settings, keyPath]);

  return (
    <Box component="span" sx={{ display: 'inline-flex', color: isOn ? onColor : offColor, transition: 'color 0.2s ease' }}><CustomButton title={isOn ? tooltipOn : tooltipOff} tooltipText={isOn ? tooltipOn : tooltipOff} iconButton color="inherit" size="large" icon={icon} onClick={() => setSetting(keyPath, !isOn)} /></Box>
  );
};

const SETTING_KEY = "IncludeDiscontinued";

export default DiscontinuedToggleButton;

type DiscontinuedToggleButtonProps = {
  settings: any;
  setSetting: (key: any, value: any) => void;

  tableName: string;
  icon: ReactElement;

  tooltipOn?: string;
  tooltipOff?: string;

  onColor?: string;
  offColor?: string;
};
